<template>
  <v-icon
    data-testid="toggletipButton"
    :aria-label="activatorLabel"
    color="hardened"
    @click="$emit('click')"
    @blur="$emit('blur')"
    @keydown.esc="$emit('blur')"
    >{{ mdiInformation }}</v-icon
  >
</template>

<script>
import { mdiInformation } from "@mdi/js";

export default {
  name: "DefaultToggletipButton",
  props: {
    activatorLabel: { type: String, default: "more info" },
  },
  data() {
    return {
      // Icons
      mdiInformation,
    };
  },
};
</script>
